import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ConfiguracionGeneralService } from '../admin.configuracion-general.module/service/configuracion-general.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConfiguracionGeneralModel } from '../admin.configuracion-general.module/service/configuracion-general.model';
import { AuthServerProvider } from '../common.module/auth/auth-jwt.service';
import { UserAuth } from '../common.module/auth/user-auth.model';
import { DataSessionShareService } from '../common.module/util/data-share-session.service';
import { ActualizaComponenteService } from './service/actualiza-componente.service';

import * as L from 'leaflet';
import { Icon } from 'leaflet';
declare var maptilersdk: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, AfterViewChecked {
  public zoom = 14;
  public latitud: number;
  public longitud: number;
  public configuracion: ConfiguracionGeneralModel = {};
  public user: UserAuth;
  public ocultarNavegacion: Boolean = true;
  public inicioSesion: Boolean;

  public map: any;
  private mapInitialized = false; // Para evitar múltiples inicializaciones

  constructor(
    private toastMsg: ToastService,
    private configuracionGeneralService: ConfiguracionGeneralService,
    private authServerProvider: AuthServerProvider,
    protected dataShare: DataSessionShareService,
    private actualizarComponenteService: ActualizaComponenteService) {
  }

  ngOnInit(): void {

    delete (Icon.Default.prototype as any)._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: 'assets/img/marker-icon-2x.png',
      iconUrl: 'assets/img/marker-icon.png',
      shadowUrl: 'assets/img/marker-shadow.png',
    });

    // este service se creo para activar o desactivar lo visible de el footer al momento de cambiar de pagina con router debido a que no se actualiza la pagina completa y se requiere acceder a estos valores.
    this.actualizarComponenteService.reloadComponent$.subscribe(componentName => {
      if (componentName === 'footer') {
        this.ocultarNavegacion = false;
        console.log(this.ocultarNavegacion);
      } if (componentName === 'footerActive') {
        this.ocultarNavegacion = true;
      }
    });
    this.user = this.authServerProvider.getUserDecoded();
    this.configuracionGeneralService.obtenerConfiguracionGeneral().then(configuracion => {
      this.configuracion = configuracion;
      this.inicioSesion = configuracion.inicio_sesion;
      this.mostrarLoginUsuarioNoLogueado();
    }, err => {
      console.log('Error al cargar la configuración en el pie de página');
      console.error(err);
    });
  }

  ngAfterViewChecked(): void {
    // if (this.configuracion.footerMap === 'leaflet' && !this.mapInitialized) {
    //   const mapContainer = document.getElementById('map');
    //   if (mapContainer) {
    //     this.initLeafletMap();
    //     this.mapInitialized = true;
    //   }
    // }
  }

  initLeafletMap() {
    // this.map = L.map('map').setView([this.configuracion.ubicacionLatitud, this.configuracion.ubicacionLongitud], this.zoom);

    // L.tileLayer('https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=co6AbKlEBAVJHDYssa0v',
    //   {
    //     maxZoom: 20,
    //     tileSize: 512,
    //     zoomOffset: -1,
    //     attribution:
    //       '<a href="https://www.maptiler.com/copyright/">© MapTiler</a> © OpenStreetMap contributors'
    //   }
    // ).addTo(this.map);

    // L.marker([this.configuracion.ubicacionLatitud, this.configuracion.ubicacionLongitud])
    //   .addTo(this.map)

    // setTimeout(() => {
    //   this.map.invalidateSize(); // Asegura que Leaflet ajuste el tamaño correctamente
    // }, 300);

    /////////////////////////////////////////
    maptilersdk.config.apiKey = 'paTFguNUHs0ydsBBwWMB';
    this.map = new maptilersdk.Map({
      container: 'map',
      style: maptilersdk.MapStyle.STREETS,
      zoom: this.zoom,
      maxZoom: 20,
      language: maptilersdk.Language.SPANISH,
      geolocateControl: false
    });
    // geolocateControl: false // Desactiva el control visual de geolocalización
    this.map.setCenter([this.configuracion.ubicacionLongitud, this.configuracion.ubicacionLatitud]);

    new maptilersdk.Marker()
      .setLngLat([this.configuracion.ubicacionLongitud, this.configuracion.ubicacionLatitud])
      .addTo(this.map);
  }

  public placeMarker() {
    console.log('placed');
  }

  public redirect(url: string) {
    window.open(url);
  }
  // este metodo valida cada vez que se carga la pagina si la navegacion de el footer se activa o no a diferencia del service que se utiliza arriba (actualizarComponenteService) este es debido a que al cambiar de pagina no actualiza variables y ese service lo hace desde el header).
  mostrarLoginUsuarioNoLogueado() {
    if (this.inicioSesion && this.user == null) {
      this.ocultarNavegacion = true;
    } else {
      this.ocultarNavegacion = false;
    }
  }


}
